<template>
  <div class="ding-supplyChain">
    <div class="ding-supplyChain-btn">
      <el-button type="primary" @click="openSupply()">申请试用</el-button>
    </div>

    <el-dialog
      title="申请试用"
      :visible.sync="supplyDialog"
      width="80%"
      class="ding-supplyDialog"
      :show-close="false"
      :before-close="handleClose">
      <el-form :model="formData" :rules="rules" ref="ruleForm">
        <el-form-item prop="userName">
          <el-input maxlength="50" v-model="formData.userName" placeholder="请输入申请人姓名"></el-input>
        </el-form-item>
        <el-form-item prop="contractPhone">
          <el-input maxlength="50" v-model="formData.contractPhone" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item prop="positionName">
          <el-input maxlength="50" v-model="formData.positionName" placeholder="请输入申请人职位"></el-input>
        </el-form-item>
        <el-form-item prop="companyName">
          <el-input maxlength="50" v-model="formData.companyName" placeholder="请输入公司名称"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="supplyDialog = false">取 消</el-button> -->
        <el-button class="ding-supplyDialog-btn" :class="supplyDisabled?'supplyChain-disabled-btn':''" type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </span>
      <img class="circle_close" @click="handleClose()" src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/circle_close.svg" alt="">
    </el-dialog>
    <div v-show="toastShow" class="toast-cont" :class="toastShow?'toast-cont-active':''">
      <i v-if="toastType=='success'" class="el-icon-success"></i>
      <i v-if="toastType=='warning'" class="el-icon-warning"></i>
      <div v-if="toastType=='success'" class="tost-icon-txt">{{successMsg||'提交成功'}}</div>
      <div v-if="toastType=='warning'" class="tost-icon-txt">{{errorMsg||'请先完善申请信息'}}</div>
    </div>
  </div>
</template>
<script>
  import * as customSensors from '@/assets/js/sensors'
  export default {
    props: [],
    data () {

      return {
        supplyDialog:false,
        formData:{
          userName:"",
          contractPhone:"",
          positionName:"",
          companyName:""
        },
        rules:{
          userName: [
            { required: true, message: '请输入姓名', trigger: 'blur' }
          ],
          companyName: [
            { required: true, message: '请输入公司名称', trigger: 'blur' }
          ],
          positionName: [
            { required: true, message: '请输入申请人职位', trigger: 'blur' }
          ],
          contractPhone: [
            { required: true, message: '电话不能为空', trigger: 'blur' },
            { validator: this.checkMobile, trigger: 'blur' }
          ]
        },
        toastType:'',
        toastShow:false,
        timer:null,
        errorMsg:'',
        successMsg:''
      }
    },
    components: {

    },
    created () {

    },
    computed:{
      supplyDisabled(){

        if(!this.formData.userName&&!this.formData.contractPhone&&!this.formData.positionName&&!this.formData.companyName){
          return true
        }else{
          return false
        }
      }
    },
    mounted () {

    },
    methods: {

      checkMobile (rule, value, callback){
        var reg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        var isMob=  /^0\d{2,3}-?\d{7,8}$/;// 座机格式
        if (!reg.test(value)&&!isMob.test(value)) {
          return callback(new Error('请输入有效的联系电话'));
        }else{
          return callback();
        }
      },
      // 打开申请弹窗
      openSupply(){
        this.supplyDialog=true
      },
      toPath(url){
        window.location.href=url
      },
      // 关闭弹窗
      handleClose(){
        this.supplyDialog=false
        this.resetForm('ruleForm')
        this.initsupplyDialog()
        customSensors.customPopupClick({
          popup_name: '申请试用',
          button_name: '取消'
        })
      },
      // 重置弹窗内容
      initsupplyDialog(){
        this.formData={
          userName:"",
          contractPhone:"",
          positionName:"",
          companyName:""
        }
        this.resetForm('ruleForm')
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$axios.post('/onelink.mdata.main.api/task/addApplyUse', {
              taskSource: 0,
              userName: this.formData.userName,
              positionName:this.formData.positionName,
              contractPhone: this.formData.contractPhone,
              companyName: this.formData.companyName,
              operateStaus: 0
            }).then((res) => {
              this.data = res.data;
              let code = this.data.code;
              if(code==0){
                if(this.getToken('isLogin') == ''){
                  if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
                    // this.$message({
                    //   dangerouslyUseHTMLString: true,
                    //   message: '<strong>试用申请已提交,请到PC端, <span style="color:red">三分钟快速注册</span></strong>'
                    // });
                    this.successMsg='试用申请已提交,请到PC端,三分钟快速注册'
                    this.toastType='success'
                    this.toastShow=true
                    this.timer=setTimeout(()=>{
                      this.toastShow=false
                      clearTimeout(this.timer)
                    },3000)
                    this.supplyDialog=false
                  } else {
                    this.$message({
                      dangerouslyUseHTMLString: true,
                      message: '<strong>试用申请已提交, <a href="/register" style="color:red">三分钟快速注册</a></strong>'
                    });
                    return;
                  }

                }else{
                //   this.$message({
                //      message: "试用申请已提交",
                //      type: 'success'
                //  });

                  this.toastType='success'
                  this.toastShow=true
                  this.timer=setTimeout(()=>{
                    this.toastShow=false
                    clearTimeout(this.timer)
                  },3000)
                }
                this.supplyDialog=false
              }else{
                // this.$message({
                //      message: "试用提交失败!",
                //      type: 'error'
                //  });

                this.toastType='warning'
                this.toastShow=true
                this.errorMsg=res.data.errorMsg
                this.timer=setTimeout(()=>{
                  this.toastShow=false
                  clearTimeout(this.timer)
                },3000)
                this.supplyDialog=false
              }
              this.initsupplyDialog()
            }).catch((err) => {
              console.log(err)
            }).finally(() => {
                customSensors.customPopupClick({
                  popup_name: '申请试用',
                  button_name: '确定'
                })
            })
          } else {

            this.toastType='warning'
            this.toastShow=true
            this.errorMsg=''
            this.timer=setTimeout(()=>{
              this.toastShow=false
              clearTimeout(this.timer)
            },3000)
            return false;
          }

          // if (valid) {
          //   this.toastType='success'
          //   this.toastShow=true
          //   this.timer=setTimeout(()=>{
          //     this.toastShow=false
          //     clearTimeout(this.timer)
          //   },3000)
          //   this.supplyDialog=false
          // } else {
          //   this.toastType='warning'
          //   this.toastShow=true
          //   this.timer=setTimeout(()=>{
          //     this.toastShow=false
          //     clearTimeout(this.timer)
          //   },3000)
          //   console.log('error submit!!');
          //   return false;
          // }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/dingWorkbench/supplyChain.vue